export * from '@fhs/routing/src/routes/v2/signin/(signin)';
export { default } from '@fhs/routing/src/routes/v2/signin/(signin)';